import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import LeMiscanthus from "./pages/LeMiscanthus";
import LaPaille from "./pages/LaPaille";
import LesRhizomes from "./pages/LesRhizomes";
import Produits from "./pages/Produits";
import LExploitation from "./pages/LExploitation";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/le-miscanthus" element={<LeMiscanthus />} />
          <Route path="/la-paille" element={<LaPaille />} />
          <Route path="/les-rhizomes" element={<LesRhizomes />} />
          <Route path="/produits" element={<Produits />} />
          <Route path="/exploitation" element={<LExploitation />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
